module.exports = __webpack_public_path__ + "img/khabarovsk.130dcb99.png";